import _ from 'lodash';

import { mimeTypes } from '../file/mime-type';
import { marks } from "../marks";
import { ncMarks } from '../nc-marks';

export const createFileMark = (object) => {
  const fileType = object.mimeType ? object.mimeType.split('/')[0] : null;
  
  // console.log(object.mimeType)
  let fileMark = marks.fileTextOMark;

  if (fileType === 'image') {
    // fileMark = marks.fileImageOMark;
    fileMark = (
      <span style={{ color: "blue" }}>{ncMarks.fileImageOMark}</span>
    );
  }

  if (fileType === 'video') {
    // fileMark = marks.fileVideoOMark;
    fileMark = (
      <span style={{ color: "brown" }}>{ncMarks.fileVideoOMark}</span>
    );
  }

  if (fileType === 'audio') {
    // fileMark = marks.fileAudioOMark;
    fileMark = (
      <span style={{ color: "brown" }}>{ncMarks.fileAudioOMark}</span>
    );
  }

  if (fileType === 'text') {
    // fileMark = marks.fileTextOMark;
    fileMark = (
      <span style={{ color: "black" }}>{ncMarks.fileTextOMark}</span>
    );
  }

  if (object.mimeType === mimeTypes.pdf) {
    // fileMark = marks.filePdfOMark;
    fileMark =  (
      <span style={{ color: "rgb(150, 0, 0)" }}>{ncMarks.filePdfOMark}</span>
    );
  }

  if (object.mimeType === mimeTypes.xlsx) {
    fileMark = marks.tableMark;
  }

  return fileMark;
};


export const createSortedTopLevels = (topLevels) => {
  const folderList = [];
  const fileList = [];

  console.log('topLevels', topLevels);
  topLevels.forEach(ele => {
    if (ele && ele.Key && ele.Key.endsWith('/')) {
      folderList.push(ele);
    }
    if (ele && ele.Key && !ele.Key.endsWith('/')) {
      fileList.push(ele);
    }
  });

  const sortedFileList = _.sortBy(fileList, [function(o) {
    const fileName = o.Key.split('/')[o.Key.split('/').length - 1];
    const timeEndIndex = fileName.indexOf('Z');
    // console.log(fileName, timeEndIndex);
    return fileName.slice(timeEndIndex+2).toLowerCase();
  }]);

  // console.log(folderList, fileList, sortedFileList);
  const sortedTopLevels = folderList.concat(sortedFileList);

  return sortedTopLevels;
};